import useListTicket from 'app/pages/NewAccount/hooks/useListTicket';
import ListTicketLayout from 'app/pages/NewAccount/layouts/ListTicketLayout';
import {
  ListTicketViewProps,
  ListTicketViewRef,
} from 'app/pages/NewAccount/types';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

const ListCancelTicket = forwardRef<ListTicketViewRef, ListTicketViewProps>(
  ({ activeKeyTab, setLoading, loading }, ref) => {
    const isActiveCurrentTab = activeKeyTab === 'tab-3';
    const [isDisplayData, setIsDisplayData] = useState(isActiveCurrentTab);

    const {
      listTicket: listTicketSuccess,
      paginator,
      search,
      optionsGetListOrder,
    } = useListTicket({
      orderState: 'cancelled',
      isActiveTab: isActiveCurrentTab,
      setLoading,
      onFinally: () => {
        setIsDisplayData(true);
      },
    });
    useImperativeHandle(ref, () => {
      return {
        search,
        getCurrentSearchOpt: () => optionsGetListOrder,
      };
    });

    useEffect(() => {
      if (!isActiveCurrentTab) setIsDisplayData(false);
    }, [isActiveCurrentTab]);

    return (
      <ListTicketLayout
        loading={loading}
        paginator={paginator}
        listTicket={isDisplayData ? listTicketSuccess : []}
        search={search}
        orderState="cancelled"
        setIsLoading={setLoading}
        activeKeyTab={activeKeyTab}
      />
    );
  },
);

export default ListCancelTicket;
